/* Epuration des devis - Les Lunettes de Pauline
   Genere par build-bundle.js a partir de epurer.js, ne pas editer a la main.
   Genere le 2026-09-21
   Complete window.DevisNormalise. A charger APRES devis-normalise.js. */
(function (global) {
  'use strict';
/* =====================================================================
   Epuration : retire d'un devis compose tout ce qui releve de la donnee
   de sante, et ne garde que ce qui prouve qu'un devis a ete etabli.

   Ce qui reste : le libelle commercial, le code LPP, le code de
   regroupement, les montants. Ce qui part : la sphere, le cylindre,
   l'axe, l'addition, l'ecart pupillaire, et toute valeur dioptrique
   qui se serait glissee dans un libelle ou une alerte.

   Le code de regroupement (V01, VU2, M03...) reste : il designe une
   famille tarifaire tres large, il est indispensable pour qu'une
   archive ait un sens, et il ne permet pas de reconstituer la
   correction d'une personne.
   ===================================================================== */

/* Chaque motif capture le mot, jamais la valeur : on garde
   "sphere hors des bornes", on jette "sphere -6,50". */
const MOTIFS = [
  /\b(sph|sphere|sphère|cyl|cylindre|axe|axis|add|addition|ep|pd|écart pupillaire|ecart pupillaire)\b\s*:?\s*[-+]?\d+(?:[.,]\d+)?(?:\s*(?:°|dioptries?))?/gi,
  /\b(od|og|oeil droit|oeil gauche|œil droit|œil gauche)\b\s*:?\s*[-+]\d+(?:[.,]\d+)?/gi,
  /(^|[\s(\/])[-+]\d+[.,]\d{2}(?=$|[\s)\/])/g,
];

/** Retire d'un texte toute valeur de correction. */
function sansCorrection(texte) {
  if (texte == null) return texte;
  let s = String(texte);
  s = s.replace(MOTIFS[0], '$1').replace(MOTIFS[1], '$1').replace(MOTIFS[2], '$1');
  // Une etiquette en capitales qui a perdu sa valeur n'est plus qu'un
  // debris : SPH, CYL, AXE. Le mot en minuscules, lui, est un mot de
  // phrase ("sphere hors des bornes") et reste.
  s = s.replace(/\b(?:SPH|CYL|AXE|AXIS|ADD|EP|PD)\b[\s,;:]*/g, ' ');
  return s
    .split('/').map((x) => x.trim())
    .filter((x) => x && !/^(sph|sph\u00e8re|sphere|cyl|cylindre|axe|axis|add|addition)$/i.test(x))
    .join(' / ')
    .replace(/^(?:(?:sph|sphère|sphere|cyl|cylindre|axe|axis|add|addition)[\s,;:\-\u2013\u2014]+)+/i, '')
    .replace(/[\s,;:\-\u2013\u2014]+(?:sph|sphère|sphere|cyl|cylindre|axe|axis|add|addition)$/i, '')
    .replace(/^[\s\-–—,;:]+/, '')
    .replace(/[\s\-–—,;:]+$/, '')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

/** Le code de regroupement d'une ligne, s'il y en a un. */
function codeRegroupement(ligne) {
  const m = /regroupement\s+([A-Z]{1,2}\d{1,2}|[A-Z]\d{2})/i.exec(ligne.detail || '');
  return m ? m[1].toUpperCase() : null;
}

/** Une ligne de devis, debarrassee de la correction. */
function epurerLigne(ligne, classe) {
  const code = codeRegroupement(ligne);
  let detail;
  if (code) {
    detail = (classe ? 'Classe ' + classe + ' — regroupement ' : 'Regroupement ') + code;
  } else {
    detail = sansCorrection(ligne.detail);
  }
  return {
    libelle: sansCorrection(ligne.libelle),
    detail,
    code: ligne.code,
    prix: ligne.prix,
    base: ligne.base,
    amo: ligne.amo,
    rac: ligne.rac,
  };
}

/** Les blocs du devis, debarrasses de la correction. */
function epurerBlocs(blocs) {
  return (blocs || []).map((b) => ({
    titre: b.titre,
    classe: b.classe,
    racNul: b.racNul,
    lignes: (b.lignes || []).map((l) => epurerLigne(l, b.classe)),
    totaux: b.totaux,
  }));
}

/**
 * L'enregistrement d'archive d'un devis : ce qui part vers l'archive et
 * ce qui est ecrit dans les attributs de panier. Aucune correction,
 * jamais.
 */
function epurer(p) {
  return {
    v: 4,
    numero: p.numero,
    emis: p.emis,
    type: p.type || 'unifocal',
    age: p.age || 'adulte',
    blocs: epurerBlocs(p.blocs),
    alertes: (p.alertes || []).map(sansCorrection).filter(Boolean),
  };
}

/**
 * Filet de securite : rend vrai si un objet contient encore quelque
 * chose qui ressemble a une correction, par un nom de champ ou par une
 * valeur. Sert cote serveur pour refuser un envoi douteux, et cote
 * tests pour verifier l'epuration.
 */
const CHAMPS_INTERDITS =
  /^(sph|sphere|sphère|cyl|cylindre|axe|axis|add|addition|pd|ep|ecart|écart|correction|prescription|ordonnance|prescripteur|doctorname|customername|brut)$/i;

function contientCorrection(valeur, chemin) {
  chemin = chemin || '';
  if (valeur === null || valeur === undefined) return null;
  if (typeof valeur === 'string') {
    return MOTIFS.some((m) => { m.lastIndex = 0; return m.test(valeur); })
      ? (chemin || 'texte') : null;
  }
  if (typeof valeur !== 'object') return null;
  if (Array.isArray(valeur)) {
    for (let i = 0; i < valeur.length; i++) {
      const t = contientCorrection(valeur[i], chemin + '[' + i + ']');
      if (t) return t;
    }
    return null;
  }
  for (const cle of Object.keys(valeur)) {
    if (CHAMPS_INTERDITS.test(cle)) return chemin + '.' + cle;
    const t = contientCorrection(valeur[cle], chemin + '.' + cle);
    if (t) return t;
  }
  return null;
}


  const D = global.DevisNormalise || (global.DevisNormalise = {});
  D.epurer = epurer;
  D.epurerBlocs = epurerBlocs;
  D.sansCorrection = sansCorrection;
  D.contientCorrection = contientCorrection;
})(typeof window !== 'undefined' ? window : globalThis);
